<div class="qr-redirect-container">
  <!-- Loading state -->
<div *ngIf="isLoading" class="state-block">
  
  <!-- 🔥 STRONG TOP LOADER -->
  <mat-progress-bar 
    mode="indeterminate" 
    color="primary" 
    class="top-progress-bar">
  </mat-progress-bar>

  <h2 class="heading">Processing Payment</h2>
  <p class="message">Please wait while we redirect you to the payment gateway.</p>
  <p class="warning">Do not press the back button or close this tab.</p>

  <!-- 🔥 ADD CENTER SPINNER (better UX) -->
  <div class="spinner"></div>

</div>

  <!-- Redirecting state -->
<div *ngIf="isRedirecting" class="state-block">
  <h2 class="heading">Redirecting...</h2>
  <p class="message">Redirecting to payment gateway. Please wait.</p>
</div>

  <!-- Error state -->
  <div *ngIf="!isLoading && errorMessage" class="state-block error-block">
    <p class="error-message">{{ errorMessage }}</p>
  </div>
</div>
